import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ScaleService } from './shared/service/scale.service';
import { Router } from '@angular/router';
import { PermissionsService } from './services/permissions.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'orgappfe';
  constructor(public translate: TranslateService, private scaleService: ScaleService, public router: Router,
    private permissionsService: PermissionsService
  ) {
    // Define supported languages
    translate.addLangs(['de', 'fr', 'it', 'en']);
    // Fallback language in case the user's language is not supported
    const fallbackLang = 'de';
    // Get the user's language from the browser, e.g., 'de', 'fr', 'it', 'en'
    const browserLang = translate.getBrowserLang() || fallbackLang; // Default to fallback if undefined
    // Set the default language
    translate.setDefaultLang(fallbackLang);

    // Use the detected browser language if it's supported; otherwise, use the fallback
    if (this.translate.getLangs().includes(browserLang)) {
      this.translate.use(browserLang);
    } else {
      this.translate.use(fallbackLang);
    }
  }

  ngOnInit(): void {
    this.updateViewportScale();
  const token = sessionStorage.getItem('ACCESS_TOKEN');
  const locationId = sessionStorage.getItem('baseLocationId');

  if (token && locationId) {// to load base location permission upon refresh
    this.permissionsService.loadUserRoleAndPermissions().subscribe();
  }
  }

  isPrintPage(): boolean {
    return this.router.url.startsWith('/employee-timesheet');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void { this.updateViewportScale() }

  private updateViewportScale(): void {
    if (typeof window !== 'undefined') {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      this.scaleService.updateScale(viewportWidth, viewportHeight) ;
    }
  }
}